import { BlogList } from '@/blocks/BlogList'
import type { ProductKeys } from '@/components/Products/constants'
import { LATEST_ARTICLES_SORT } from '@/core/blog/constants'
import type { CardArticleEntryData } from '@/models'
import { ArticlesContextProvider } from '@/providers'

interface RelatedArticlesSectionProps {
  articles: CardArticleEntryData[]
  product: ProductKeys
}

export const RelatedArticlesSection = ({ articles, product }: RelatedArticlesSectionProps) => (
  <ArticlesContextProvider articles={articles} sort={LATEST_ARTICLES_SORT} product={product}>
    <BlogList title={{ text: 'Artigos relacionados', tag: 'h2' }} isSlider space="3" />
  </ArticlesContextProvider>
)
